import styled, { keyframes } from 'styled-components';

const heroRise = keyframes`
  from { opacity: 0; transform: translateY(28px); }
  to { opacity: 1; transform: translateY(0); }
`;

const imageReveal = keyframes`
  from { opacity: 0; transform: scale(1.08); }
  to { opacity: 1; transform: scale(1); }
`;

export const HeroContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 30px;
  height: 100vh;
  position: relative;
  z-index: 1;
  overflow: hidden;
  background: #87cefa;
`;

export const HeroBg = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  
  .hero-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 1;
    animation: ${imageReveal} 1.4s ease-out both;
  }
`;

export const HeroContent = styled.div`
  z-index: 3;
  max-width: 1200px;
  position: absolute;
  padding: 8px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  animation: ${heroRise} 0.9s 0.25s ease-out both;

  .h1-hero {
    color: #fff;
    font-size: clamp(2.2rem, 5vw, 4rem);
    line-height: 1.1;
    letter-spacing: 0.02em;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7);
  }

  .hero-text {
    margin-top: 24px;
    color: #fff;
    font-size: clamp(1.15rem, 2vw, 1.5rem);
    letter-spacing: 0.12em;
    text-transform: uppercase;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7);
  }
`;

export const HeroBtnWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  justify-content: center;

  button {
    margin: 0 10px;
    padding: 12px 24px;
    font-size: 16px;
    border: none;
    border-radius: 4px;
    background-color: #ffa500;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    box-shadow: 0 8px 20px rgba(0, 0, 128, 0.2);

    &:hover {
      background-color: #fff;
      color: #000080;
      transform: translateY(-3px);
      box-shadow: 0 12px 26px rgba(0, 0, 128, 0.28);
    }
  }
`;
